import { env } from '@/shared/config'

type YandexMetricaEvent = {
    name: string
    properties?: Record<string, unknown>
}

export const yandexMetrica = {
    sendEvent: (e: YandexMetricaEvent) => {
        if (env.YM_COUNTER_ID) {
            ym(env.YM_COUNTER_ID, 'reachGoal', e.name, e.properties)
        }
    },
}
